import type { RichTextReplacements } from '../../helpers/builderRichTextParser'
import { parseBuilderRichText } from '../../helpers/builderRichTextParser'
import type { BuilderCustomComponentProps } from '../../types/builderio-ids'
import { A, Body, H2, H3, H4, Ol, Paragraph, Ul } from './articleBody.styles'

interface ArticleBodyProps extends BuilderCustomComponentProps {
  body: string
}

const replacements: RichTextReplacements = [
  { nodeName: 'strong', Component: 'b' },
  { nodeName: 'h2', Component: H2 },
  { nodeName: 'h3', Component: H3 },
  { nodeName: 'h4', Component: H4 },
  { nodeName: 'p', Component: Paragraph },
  { nodeName: 'ol', Component: Ol },
  { nodeName: 'ul', Component: Ul },
  { nodeName: 'a', Component: A },
]

const BlogPostBody = ({ body, attributes }: ArticleBodyProps): JSX.Element => (
  <Body {...attributes}>{parseBuilderRichText(body, replacements)}</Body>
)

export default BlogPostBody
